import React from "react";
import styled from "styled-components";

interface ITextField {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder: string;
}

const TextField: React.FC<ITextField> = (props) => {
  const { value, onChange, label, placeholder } = props;

  return (
    <InputWrapper>
      <Label>{label}</Label>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </InputWrapper>
  );
};

export default TextField;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Label = styled.label`
  font-size: 0.6rem;
  color: #888;
`;

const Input = styled.input`
  width: 100%;
  padding: 1rem;
  background: #111;
  border: 2px solid #333;
  border-radius: 8px;
  color: #00ff00;
  font-size: 0.8rem;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #00ff00;
  }

  &::placeholder {
    color: #444;
  }
`;
